import { ImageMap, getImage, importAll } from "..";

declare const require: any;

const imagesEconomy: ImageMap = importAll(
  require.context("../economy", false, /\.(png|jpe?g|svg)$/)
);

export default imagesEconomy;
export const getTemplateCultureImg = (valueTemplateImage: string) => {
  const filteredImages = Object.entries(imagesEconomy).find(
    ([item, value], index) => getImage(item) === valueTemplateImage
  );
  if (filteredImages) return filteredImages[1];
  else return "";
};
